module.exports = __webpack_public_path__ + "img/price.456d4fc2.svg";